export enum Categories {
    deepSky = "Deep Sky",
    solarSystem = "Solar System",
    starscape = "Starscape",
    events = "Events",
}
